import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, Flex, List, Calendar } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/TeamStatistic.css';
import CommonUtils from '../utils/CommonUtils';

const history = require("history").createHashHistory()

class TeamStatistic extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        let agentId = decodeURIComponent(this.props.match.params.agentId)

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            selectedItem: null,
            agents: [],
            selectedAgent: agentId?agentId:'',
            showCalendar: false,
            dateRange: {
                start: new Date(),
                end: new Date()
            },
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 165;
        this.setState({
            height
        })
        this.loadTeamMembers(() => {
            this.loadPageData(1, height)
        })
    }

    loadPageData = (pageNum) => {
        const { selectedAgent, dateRange } = this.state

        DataFetcher.pageTeamSite({
            pageNum,
            pageSize: 10,
            agentId: selectedAgent,
            fromDate: CommonUtils.formatDate(dateRange.start),
            toDate: CommonUtils.formatDate(dateRange.end)
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    loadTeamMembers = (callback) => {
        DataFetcher.listTeamMember({
            success: (resp) => {
                this.setState({
                    agents: resp.data
                }, () => {
                    callback&&callback()
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onAgentPickerChange = (val) => {
        this.setState({
            selectedAgent: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    onCalendarConfirm = (startDate, endDate) => {
        this.setState({
            showCalendar: false,
            dateRange: {
                start: startDate,
                end: endDate
            }
        }, () => {
            this.loadPageData(1)
        })
    }

    onCalendarCancel = () => {
        this.setState({
            showCalendar: false
        })
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        return (
            <WingBlank size='sm'>
                <div>
                    <Card>
                        <Card.Header
                            title={
                                <div style={{fontSize: 15}}>
                                    {rowData.siteName}
                                    <span style={{fontWeight: 'normal', color: 'gray', fontSize: 13}}>&nbsp;({rowData.statistic.totalDeviceCount}台)</span>
                                </div>
                            }
                            extra={<span style={{fontSize: 12, color: 'gray'}}>{rowData.agentName}</span>}
                        />
                        <Card.Body>
                            <Flex>
                                <Flex.Item>
                                    <div className='value'><span className='unit'>￥</span>{rowData.statistic.teamProfitAmount}</div>
                                    <div className='label'>总提成</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='value'><span className='unit'>￥</span>{rowData.statistic.teamPacketProfitAmount}</div>
                                    <div className='label'>订单提成</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='value'><span className='unit'>￥</span>{rowData.statistic.teamRechargeProfitAmount}</div>
                                    <div className='label'>充值提成</div>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size='md'/>
                            <Flex>
                                <Flex.Item>
                                    <div className='value'><span className='unit'>￥</span>{rowData.statistic.salesAmount}</div>
                                    <div className='label'>销售额</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='value'>{rowData.statistic.dealPacketCount}</div>
                                    <div className='label'>成交订单</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='value'>{rowData.statistic.dealRechargeCount}</div>
                                    <div className='label'>充值单数</div>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size='md'/>
                            <Flex>
                                <Flex.Item>
                                    <div className='value'>{rowData.statistic.totalUserCount}</div>
                                    <div className='label'>用户数</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='value'>{rowData.statistic.intendPacketCount}</div>
                                    <div className='label'>意向订单</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='value'>{rowData.statistic.offlineDeviceCount}</div>
                                    <div className='label'>离线设备</div>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size='md'/>
                            <div className={`word-ellipsis${CommonUtils.isEmpty(rowData.address)?' hide':''}`} style={{width:'100%', fontSize: 12, color: '#999', textAlign: 'center', paddingTop: 10}}>
                                <i className='iconfont icon-shouhuodizhi' style={{fontSize: 12}}/>
                                <span>&nbsp;&nbsp;{rowData.provinceName}{rowData.cityName}{rowData.countyName}{rowData.address}</span>
                            </div>
                        </Card.Body>
                        
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { agents, selectedAgent, dateRange } = this.state;
        const pickerData = agents.map(item => ({value: item.agentId, label: item.agentName}))
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedAgent]}
                        onOk={this.onAgentPickerChange}
                        data={[{label: '所有成员', value: ''}, ...pickerData]}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 团队成员</span>
                        </List.Item>
                    </Picker>
                    <div className='date-range-picker' onClick={() => {
                        this.setState({
                            showCalendar: true
                        })
                    }}>
                        <span className='symbol'>
                            <i className='iconfont icon-rili'/>
                        </span>
                        <span className='date'>{CommonUtils.formatDate(dateRange.start)}</span>
                        <span className='seperator'>~</span>
                        <span className='date'>{CommonUtils.formatDate(dateRange.end)}</span>
                    </div>
                </WingBlank>
            </div>
        )
    }

    render() {
        const { dataSource, isLoading, showCalendar, dateRange } = this.state;

        return (
            <div className='page-team-statistic'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                >
                    团队数据
                </NavBar>
                {this.doRenderFilterView()}
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 135
                    }}
                />
                <Calendar
                    visible={showCalendar}
                    showShortcut={true}
                    initalMonths={12}
                    infinite={false}
                    onCancel={this.onCalendarCancel}
                    onConfirm={this.onCalendarConfirm}
                    defaultValue={[dateRange.start, dateRange.end]}
                    maxDate={new Date()}
                />
            </div>
        )
    }
}

export default createForm()(TeamStatistic);


// WEBPACK FOOTER //
// ./src/modules/TeamStatistic.js